import { render, staticRenderFns } from "./competition-ranking.vue?vue&type=template&id=00421814&scoped=true&"
import script from "./competition-ranking.vue?vue&type=script&lang=js&"
export * from "./competition-ranking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00421814",
  null
  
)

export default component.exports